import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import cx from "classnames";

export type ToggleSideMenuButtonProps = {
  /** function to handle on click functionality to toggle the side menu */
  onClick: () => void;
  /** additional class name for root element */
  rootClassName?: string;
  /** flag to check if side menu is open for mobile screens*/
  open: boolean;
};

/**
 * Toggle side menu button component for mobile navigation
 */
const ToggleSideMenuButton = ({
  onClick,
  rootClassName,
  open,
}: ToggleSideMenuButtonProps): React.ReactElement => {
  return (
    <ButtonFactory
      aria-label="Toggle side menu"
      buttonType={ButtonType.Secondary}
      data-testdata-testid="events-sia-toggle-component"
      className={cx(
        "block flex-none cursor-pointer opacity-100 duration-300",
        "h-[48px] w-[48px] border-0 px-2 !outline-none focus-within:outline-0 focus:outline-0 lg:h-9 lg:w-9 lg:hover:rounded-full lg:hover:bg-gray-250",
        { "px-3": open },
        rootClassName
      )}
      icon={
        <IconFactory
          type={open ? IconTypeEnum.close : IconTypeEnum.hamburgerForDesktop}
          x={25}
          y={25}
          size={25}
          className="mb-1 text-gray-850 xs:mb-2"
        />
      }
      onClick={onClick}
    />
  );
};

export default ToggleSideMenuButton;
